import { combineReducers } from "redux";
import { chatReducer } from "./reducers/chatReducer";
import { notificationReducer } from "./reducers/notificationReducer";
import { commonReducer } from "./reducers/commonReducer";
import { rpmReducer } from "./reducers/rpmReducer";
import { patientsReducer } from "./reducers/patientReducer";
import { criticalityReducer } from "./reducers/criticalityReducer";
import { userReducer } from "./reducers/userReducer";
// import { audioReducer } from "./reducers/audioReducer";


export default combineReducers({
  chatCount: chatReducer,
  notificationCount: notificationReducer,
  common: commonReducer,
  patients: patientsReducer,
  rpm: rpmReducer,
  criticality: criticalityReducer,
  user : userReducer,
  // audio: audioReducer,
});
